import { teammateMessageActionCardKind } from '@littlebird/action-cards';
import { cardState } from '@littlebird/action-cards-view';

import { useWikiPeopleOfUsers } from '@/features/people-wiki/use-wiki-person-of-user';

import type { ActionCard } from '@littlebird/sdk';

/** The row title of a teammate message card the app draws as itself (a reply), with the name on the other person's
 * account replaced by the name of the user's People Wiki page for them. Undefined when the title needs no change. */
export function useHivemindRowTitle(card: ActionCard): string | undefined {
  'use no memo';
  const wikiPersonOf = useWikiPeopleOfUsers();
  const teammate = teammateMessageActionCardKind.decode(card.content)?.teammate;
  const name = teammate && wikiPersonOf(teammate.id)?.name;
  const { title } = cardState(card.row);
  return teammate && name && name !== teammate.name && title
    ? title.replace(teammate.name, name)
    : undefined;
}
